<header class="main-header fixed-top">
  <div class="top-bar container-fluid">
    <div class="top-collapse">
    <button type="button" class="sidebar-collapse" data-bs-toggle="offcanvas" data-bs-target="#stSidebar"
      aria-controls="stSidebar" aria-label="Mostrar/Ocultar menú">
      <span> </span>
      <span> </span>
      <span> </span>
    </button>
    <div class="cont-logo">
    <a [routerLink]="['/home']"
      class="logo-stihl"><img
        src="/assets/images/stihl-localPlus.svg" alt="STIHL" /></a>
        <img src="assets/images/logo-100aniv.png" class="logo-100aniv" />
    </div>
    </div>
    <div class="helpUp">SUPORTE: <a href="mailto:apoio_local@stihl.pt" class="link-light">apoio_local@stihl.pt</a></div>
  </div>
  <nav class="container-fluid">
    <div class="search-form input-group">
      <fa-icon [icon]="['fas','search']"></fa-icon>
      <input type="text" (keydown.enter)="onEnterPress()" [(ngModel)]="termToSearch"
        class="form-control bg-transparent border-none strong" (keyup)="setDisableSearch()" name="searchDocument"
        id="searchDocument" aria-describedby="btnSearch" placeholder="PESQUISAR">
      <button [hidden]="disableSearch" id="clearButton" type="button"><fa-icon [icon]="['fas','xmark']"></fa-icon><span
          class="visually-hidden">Reset</span></button>
      <button data-bs-toggle="modal" data-bs-target="#modalSearch" [hidden]="disableSearch" (click)="searchContent()"
        class="btn-orange" type="button" id="btnSearch"> PESQUISAR</button>
    </div>
    <div class="header-tools">
      <button type="button" class="btn-rm icon-text" [routerLink]="['/myarea/acompanhamento-metas']">
        <img src="/assets/images/icons/icon-rm-percent.svg" title="Meus bónus" alt="Meus bónus" />
        <span>MEUS BÓNUS</span>
     </button>
     <button type="button" class="btn-rm icon-text" [routerLink]="['/forum']">
        <img src="/assets/images/icons/icon-rm-foros.svg" title="Fórum" alt="Fórum" />
        <span>FÓRUM</span>
     </button>

      <a *ngIf="this.countNotification > 0" [hidden]="false" (click)="getCountNotification(true)">
         <div class="badgeBtn">
        <img src="/assets/images/icons/ico_bell_black.svg" alt="Notificações" title="Notificações" />
        <div class="badge rounded-pill" *ngIf="this.countNotification> 0"><div>{{this.countNotification}}</div></div>
        </div>
      </a>
      <a class="not-click" *ngIf="this.countNotification <= 0">
        <img src="/assets/images/icons/ico_bell_black.svg" alt="Notificações" title="Notificações" />
      </a>

      <a (click)="logout()">
        <img src="/assets/images/icons/ico_logoff.svg" alt="Sair" title="Sair" />
      </a>
    </div>
  </nav>
</header>

<div class="modal fade" #modalSearch id="modalSearch" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="1"
  aria-labelledby="modalSearchLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 *ngIf="!searching" class="modal-title" id="modalSearchLabel">Resultados</h5>
        <div *ngIf="searching" class="loading">
          <img src="assets/images/icons/ico_loading_bar.svg" />
        </div>
        <button type="button" class="btn-close" id="closeModalButton" (click)="disableSearch=true"
          data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="bg-light py-1 px-3">
        <div class="search-form">
          <fa-icon [icon]="['fas','search']"></fa-icon>
          <input type="text" (keydown.enter)="searchContent()" [(ngModel)]="termToSearch"
            class="form-control bg-transparent border-none strong" (keyup)="setDisableSearch()"
            name="searchDocumentModal" id="searchDocumentModal" aria-describedby="btnSearch" placeholder="PESQUISAR">
          <button [hidden]="disableSearch" id="clearButtonModal" type="button"><fa-icon
              [icon]="['fas','xmark']"></fa-icon><span class="visually-hidden">Reset</span></button>
          <button class="btn-orange" [hidden]="disableSearch" (click)="searchContent()" type="button"
            id="btnSearchModal"> PESQUISAR</button>
        </div>
      </div>
      <div class="modal-body">
        <table class="table" id="tblSearch" cellspacing="0" cellpadding="0">
          <tbody>
            <tr *ngFor="let item of searchResult.items">
              <td class="w-20">
                {{item.TermTypeCode}}
              </td>
              <td class="w-10">
                <img *ngIf="item.ImageUri" class="img-fluid" [src]="item.ImageUri" alt="image" width="90" />
                <span *ngIf="!item.ImageUri">sin imagen</span>
              </td>
              <td class="text-start">
                {{ item.Title }}
                <br> {{ item.PublishDate | date: 'dd/MM/yyyy' }}

              </td>
              <td class="w-15">
                <a class="btn-orange-border btn-icon" (click)="trackDocument(item.TermTypeCode,item.Id)" type="button"
                  title="Download" [href]="item.FileUri">
                  <div class="svg-icon">
                    <svg viewBox="0 0 150 150">
                      <use xlink:href='assets/images/icons/ico_download_auto.svg#img'
                        href="assets/images/icons/ico_download_auto.svg#img"></use>
                    </svg>
                  </div>
                  Download
                </a>
              </td>
              <td class="w-15"> <button class="btn-orange" type="button" title="Ir"
                  (click)="goToSection(item.Path)">SECCÃO</button></td>
            </tr>
          </tbody>
        </table>
        <div id="search-pagination" *ngIf=" !noResult">
          <ul class="pagination">
            <li [ngClass]="{'disabled': currentPage == 0}" class="paginate_button page-item previous"
              (click)="pagingSearch(this.currentPage - 1)" id="search_results_previous">
              <a aria-controls="search_results" aria-disabled="true" aria-role="link" data-dt-idx="previous"
                tabindex="0" class="page-link">Anterior</a>
            </li>
            <li [ngClass]="{'active': currentPage == i}" *ngFor='let key of pages; let i = index' [attr.data-index]="i"
              class="paginate_button page-item" (click)="pagingSearch(i)">
              <a href="#" aria-controls="tblForumMessage" aria-role="link" aria-current="page" data-dt-idx="0"
                tabindex="0" class="page-link">{{ i + 1 }}</a>
            </li>
            <li [ngClass]="{'disabled': currentPage + 1 == pages.length}" class="paginate_button page-item next"
              (click)="pagingSearch(this.currentPage + 1)" id="search_results_next">
              <a aria-controls="search_results" aria-disabled="true" aria-role="link" data-dt-idx="next" tabindex="0"
                class="page-link">Seguinte</a>
            </li>
          </ul>
        </div>
        <div *ngIf="noResult" class="lead py-2">
          Não há resultados para esta pesquisa
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #notifications let-offcanvas>
  <div class="offcanvas-header">
    <h3 class="offcanvas-title">Notificações</h3>
    <button type="button" class="btn-close btn-close-white text-reset" aria-label="Cerrar"
      (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body">
    <ng-container *ngIf="loading">
      Carregando...
    </ng-container>
    <ng-container *ngIf="!loading">
      <ng-container *ngFor="let item of this.data">
        <div [@loadedFadeAnimation]="'visible'">
          <hr class="bg-white">
          <div [class.has-since-date]="item.PublishSince" class="notification-header">
            {{item.PublishSince}}
            <button type="button" class="btn-close btn-close-white" aria-label="Cerrar"
              (click)="closeNotification(item.IdNotification)"></button>
          </div>
          <ng-container *ngIf="item.Url != null">
            <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == true" href="{{item.Url}}"
              target="{{item.UrlOpenNew == true? '_blank':''}}" class="link-light"
              (click)="closeNotification(item.IdNotification)">
              <h4 class="notification-title">{{item.Title}}</h4>
              <div [innerHTML]="item.Content" class="notification-body external-html"></div>
            </a>
            <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == false" class="pointer"
              [routerLink]="[item.Url]" target="{{item.UrlOpenNew == true? '_blank':''}}" class="link-light"
              (click)="closeNotification(item.IdNotification)">
              <h4 class="notification-title">{{item.Title}}</h4>
              <div [innerHTML]="item.Content" class="notification-body external-html"></div>
            </a>
          </ng-container>
          <ng-container *ngIf="item.Url == null">
            <h4 class="notification-title">{{item.Title}}</h4>
            <div [innerHTML]="item.Content" class="notification-body external-html"></div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <button class="btn-light-border mt-4 w-100" (click)="loadMore()" *ngIf="showMore && this.data.length > 0">CARREGAR
      MAIS</button>
  </div>
</ng-template>